import { IoCContainer } from '../..';
import { WebCoreIoCKeys } from '../ioc/ioc.keys.class';
import { IUtils } from '../ioc/implentation/utils/utils.interface';

export class SidebarModule {
    constructor(sidebarJSObj?: any) {
        let utils: IUtils = IoCContainer.get(WebCoreIoCKeys.IUtils);
        if (sidebarJSObj != null) {
            utils.deepCopy(this, sidebarJSObj);
        }
    }

    public name: string;
    public x: number;
    public y: number;
}
